import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Icon = styled.div`
  margin-right: ${props => props.theme.spacing.s4};
`;
